/**
 * useTokenAlert - Token 欠费/预警弹窗状态（原四页面重复实现的抽取）
 *
 * 提供：弹窗状态 + setState（各页面按原用法设置 type/title/message）
 * 以及统一的关闭、去充值（新 tab 打开 shouqian 主站 Token 管理）处理。
 */
import { useState, useCallback } from 'react';
import { TOKEN_MANAGEMENT_URL } from '../config/externalLinks';

export interface TokenAlertState {
  show: boolean;
  type: 'warning' | 'zero' | 'overdraft';
  title: string;
  message: string;
  /** 大纲生成等长流程可"继续生成"时使用 */
  canContinue?: boolean;
}

export const useTokenAlert = () => {
  const [tokenAlert, setTokenAlert] = useState<TokenAlertState>({
    show: false,
    type: 'zero',
    title: '',
    message: '',
  });

  /** 关闭弹窗 */
  const closeAlert = useCallback(() => {
    setTokenAlert(prev => ({ ...prev, show: false }));
  }, []);

  /** 去充值：关弹窗并新 tab 打开主站 Token 管理页 */
  const handleRecharge = useCallback(() => {
    setTokenAlert(prev => ({ ...prev, show: false }));
    window.open(TOKEN_MANAGEMENT_URL, '_blank');
  }, []);

  return { tokenAlert, setTokenAlert, closeAlert, handleRecharge };
};

export default useTokenAlert;
